// extracted by mini-css-extract-plugin
module.exports = {"main-container":"Main_main-container__1IdiR","Shrink":"Main_Shrink__L6xHX","shrink":"Main_shrink__1Ui9j","Normal":"Main_Normal__ZA4a-","grow":"Main_grow__38twV"};